import React from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns } from './configuration';
import * as NotificationReducer from '../../../../redux/reducers/notification_reducer/selectors';
import { useDispatch } from 'react-redux';
import NotificationActions from '../../../../redux/reducers/notification_reducer/actions';
import { Box } from '@material-ui/core';
import useQuery from 'custom_hooks/useQuery';
import NavigationConfig from 'navigation/config';
import { useHistory } from 'react-router';
import { ReminderTableDefaultFetchValues } from './configuration';

export default function DatatableList() {
  const result = NotificationReducer.useGetReminderList();
  const dispatch = useDispatch();
  const query = useQuery();
  const history = useHistory();
  const sortField: string = query.get('sortField')
    ? (query.get('sortField') as string)
    : ReminderTableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY;
  const order: 'asc' | 'desc' = query.get('order')
    ? (query.get('order') as 'asc' | 'desc')
    : ReminderTableDefaultFetchValues.TABLE_DEFAULT_ORDER;
  const vatNumber = query.get('vatNumber');
  const period = query.get('period');
  const remindedDateFrom = query.get('remindedDateFrom');
  const remindedDateTo = query.get('remindedDateTo');
  const reminderPaging = result.data?.paging;
  const paging = {
    pageSize: reminderPaging
      ? reminderPaging.pageSize
      : ReminderTableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
    page: reminderPaging
      ? reminderPaging.page
      : ReminderTableDefaultFetchValues.TABLE_DEFAULT_PAGE,
    total: reminderPaging ? reminderPaging.total : 0,
  };

  return (
    <Box display="flex" flexDirection="column">
      <Datatable
        loading={true}
        sorting={{
          sortField: sortField,
          order: order,
        }}
        paging={paging}
        data={result.data?.items || []}
        columns={TableColumns}
        changePageHandle={(
          selectedPage,
          pageSize,
          nextOrder,
          nextSortField
        ) => {
          const nextParams = new URLSearchParams(query.toString());
          nextParams.set('sortField', nextSortField);
          nextParams.set('page', `${selectedPage}`);
          nextParams.set('pageSize', `${pageSize}`);
          nextParams.set('order', nextOrder);

          dispatch(
            NotificationActions.fetchReminderListAction({
              sortField: nextSortField,
              page: selectedPage,
              pageSize: pageSize,
              order: nextOrder,
              vatNumber: vatNumber,
              period: period,
              remindedDateFrom: remindedDateFrom,
              remindedDateTo: remindedDateTo,
            })
          );
          history.push(
            NavigationConfig.notificationsPage().path +
              `?${nextParams.toString()}`
          );
        }}
      />
    </Box>
  );
}
